import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId, resolveModuleSlug } from "../utilities/videoPlayerApi";

const getLessonKey = ({ course_id, module_slug, lesson_id }) =>
    `${course_id || ''}|${module_slug || ''}|${lesson_id ?? ''}`;

export const fetchLessonQuiz = createAsyncThunk(
    'lessonQuiz/fetchLessonQuiz',
    async ({ course_id, module_slug, video_id, lesson_id, goal }, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const moduleSlug = resolveModuleSlug(module_slug);
        const response = await axiosAuth.post(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${moduleSlug}/lessons/${lesson_id}/quiz/question`,
            { goal: goal || null, video_id: video_id || null }
        );
        return response.data;
    }
);

const initialState = {
    quiz: {},
    quizFor: null,
    quizLoading: false,
    showQuizModal: false,
};

const lessonQuizSlice = createSlice({
    name: 'lessonQuiz',
    initialState,
    reducers: {
        setShowQuizModal: (state, action) => {
            state.showQuizModal = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLessonQuiz.pending, (state) => {
                state.quizLoading = true;
            })
            .addCase(fetchLessonQuiz.fulfilled, (state, action) => {
                state.quizLoading = false;
                state.quiz = action.payload ?? {};
                state.quizFor = getLessonKey({
                    course_id: action.meta.arg.course_id,
                    module_slug: action.meta.arg.module_slug,
                    lesson_id: action.meta.arg.lesson_id,
                });
            })
            .addCase(fetchLessonQuiz.rejected, (state) => {
                state.quizLoading = false;
            });
    },
});

export const { setShowQuizModal } = lessonQuizSlice.actions;
export const selectLessonQuiz = (state) => state.lessonQuiz?.quiz;
export const selectModalStatus = (state) => state.lessonQuiz?.showQuizModal;
export const selectQuizGeneratedForLesson = (state, courseId, moduleSlug, lessonId) =>
    state.lessonQuiz?.quizFor === getLessonKey({
        course_id: courseId,
        module_slug: moduleSlug,
        lesson_id: lessonId,
    });
export const selectGeneratedQuizQuestion = (state, courseId, moduleSlug, lessonId) => {
    if (!selectQuizGeneratedForLesson(state, courseId, moduleSlug, lessonId)) return '';
    return state.lessonQuiz?.quiz?.question ?? '';
};
export default lessonQuizSlice.reducer;
